import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    languageData: [],
};
const getters = {
    getLocaleOptions: state => state.languageData
};

const mutations = {
    LANGUAGE_INFO(state, data) {
        state.languageData = data
    }
};


const actions = {
    getLanguageData({commit}) {
        axiosGet(`crm/languages`).then((response) => {
            commit('LANGUAGE_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};




console.log('language' + JSON.stringify(state.languageData));

export default {
    state,
    getters,
    mutations,
    actions
}



